type RichTextEditorTranslate = (key: string, options?: Record<string, unknown>) => string

export type RichTextEditorCopy = {
    editorPlaceholder: string
    toolbar: {
        insertTag: string
        moreActions: string
        bold: string
        italic: string
        strikethrough: string
        highlight: string
        link: string
    }
    tags: {
        search: string
        empty: string
        sample: string
        ungrouped: string
    }
    groups: {
        inline: string
        text: string
        lists: string
        other: string
    }
    blocks: {
        h1: string
        h2: string
        h3: string
        quote: string
        divider: string
        bulletList: string
        orderedList: string
        taskList: string
        codeBlock: string
        table: string
        image: string
    }
    errors: {
        tagsNotAllowed: (tags: string) => string
        minLength: (length: number) => string
        maxLength: (length: number) => string
    }
}

export const getRichTextEditorCopy = (t: RichTextEditorTranslate): RichTextEditorCopy => ({
    editorPlaceholder: t('components.ui.richTextEditor.editorPlaceholder'),
    toolbar: {
        insertTag: t('components.ui.richTextEditor.toolbar.insertTag'),
        moreActions: t('components.ui.richTextEditor.toolbar.moreActions'),
        bold: t('components.ui.richTextEditor.toolbar.bold'),
        italic: t('components.ui.richTextEditor.toolbar.italic'),
        strikethrough: t('components.ui.richTextEditor.toolbar.strikethrough'),
        highlight: t('components.ui.richTextEditor.toolbar.highlight'),
        link: t('components.ui.richTextEditor.toolbar.link'),
    },
    tags: {
        search: t('components.ui.richTextEditor.tags.search'),
        empty: t('components.ui.richTextEditor.tags.empty'),
        sample: t('components.ui.richTextEditor.tags.sample'),
        ungrouped: t('components.ui.richTextEditor.tags.ungrouped'),
    },
    groups: {
        inline: t('components.ui.richTextEditor.groups.inline'),
        text: t('components.ui.richTextEditor.groups.text'),
        lists: t('components.ui.richTextEditor.groups.lists'),
        other: t('components.ui.richTextEditor.groups.other'),
    },
    blocks: {
        h1: t('components.ui.richTextEditor.blocks.h1'),
        h2: t('components.ui.richTextEditor.blocks.h2'),
        h3: t('components.ui.richTextEditor.blocks.h3'),
        quote: t('components.ui.richTextEditor.blocks.quote'),
        divider: t('components.ui.richTextEditor.blocks.divider'),
        bulletList: t('components.ui.richTextEditor.blocks.bulletList'),
        orderedList: t('components.ui.richTextEditor.blocks.orderedList'),
        taskList: t('components.ui.richTextEditor.blocks.taskList'),
        codeBlock: t('components.ui.richTextEditor.blocks.codeBlock'),
        table: t('components.ui.richTextEditor.blocks.table'),
        image: t('components.ui.richTextEditor.blocks.image'),
    },
    errors: {
        tagsNotAllowed: (tags) => t('components.ui.richTextEditor.errors.tagsNotAllowed', { tags }),
        minLength: (length) => t('components.ui.richTextEditor.errors.minLength', { length }),
        maxLength: (length) => t('components.ui.richTextEditor.errors.maxLength', { length }),
    },
})
